import { useTranslation } from 'react-i18next';
import { setLanguage } from '../i18n';
import { api } from '../api';
import { useAuth } from '../auth';

export function LanguageSwitch() {
  const { i18n } = useTranslation();
  const { user } = useAuth();
  const current = i18n.language.startsWith('en') ? 'en' : 'de';

  function change(lang: 'de' | 'en') {
    setLanguage(lang);
    if (user) void api.auth.setLanguage(lang).catch(() => undefined);
  }

  return (
    <div className="tabs" role="group" aria-label="Language" style={{ padding: 3 }}>
      <button
        className={current === 'de' ? 'active' : ''}
        onClick={() => change('de')}
        aria-pressed={current === 'de'}
      >
        DE
      </button>
      <button
        className={current === 'en' ? 'active' : ''}
        onClick={() => change('en')}
        aria-pressed={current === 'en'}
      >
        EN
      </button>
    </div>
  );
}
